import { mapState } from 'vuex'

const ACTION_CONFIG = {
  USER_CHANGED_GROUP:  { icon: 'mdi-account-switch', color: '#4A90D9', label: 'MOVIDO' },
  USER_ADDED_TO_GROUP: { icon: 'mdi-account-plus', color: '#27AE60', label: 'ADICIONADO' },
  USER_CHANGED_SCALE:  { icon: 'mdi-swap-horizontal', color: '#E67E22', label: 'MOVIDO' },
  USER_ADDED_TO_SCALE: { icon: 'mdi-clipboard-plus', color: '#27AE60', label: 'ADICIONADO' },
  USER_PROMOTION:      { icon: 'mdi-shield-account', color: '#D4A017', label: 'PROMOVIDO' },
  DUTY_TRANSFER:       { icon: 'mdi-transfer', color: '#4A90D9', label: 'TRANSFERIDO' },
  DUTY_ACCEPT:         { icon: 'mdi-check-circle', color: '#27AE60', label: 'ACEITO' },
}

const DEFAULT_CONFIG = { icon: 'mdi-bell', color: '#999', label: 'AÇÃO' }

export default {
  name: 'NotificationCenter',

  data: () => ({
    loading: true,
    now: Date.now(),
    ticker: null,
  }),

  computed: {
    ...mapState('notifications', ['notifications', 'newNotificationIds', 'hasMore', 'loadingMore']),
    ...mapState({ groups: state => state.app.groups }),
  },

  watch: {
    groups: {
      immediate: true,
      handler (groups) {
        if (groups && groups.length > 0) {
          this.loadNotifications()

          const groupIDs = this.getGroupIDs()

          if (!this.$store.state.notifications.isPolling) {
            this.$store.dispatch('notifications/startPolling', groupIDs)
          }
        }
      },
    },
  },

  mounted () {
    this.ticker = setInterval(() => {
      this.now = Date.now()
    }, 30000)
  },

  beforeDestroy () {
    if (this.ticker) clearInterval(this.ticker)
  },

  methods: {
    async loadNotifications () {
      this.loading = true

      const groupIDs = this.getGroupIDs()

      if (groupIDs.length > 0) {
        await this.$store.dispatch('notifications/fetchNotifications', groupIDs)
        this.$store.dispatch('notifications/markAllAsRead')
      }

      this.loading = false
    },

    markAllAsRead () {
      this.$store.dispatch('notifications/markAllAsRead')
    },

    loadMore () {
      const groupIDs = this.getGroupIDs()
      this.$store.dispatch('notifications/loadMore', groupIDs)
    },

    getGroupIDs () {
      return (this.groups || []).map(g => g.groupID).filter(Boolean)
    },

    isNew (id) {
      return this.newNotificationIds.includes(id)
    },

    getActionConfig (actionName) {
      return ACTION_CONFIG[actionName] || DEFAULT_CONFIG
    },

    formatDate (datetime) {
      if (!datetime) return ''

      const date = new Date(datetime)

      return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    },

    timeAgo (unixtimestamp) {
      if (!unixtimestamp) return ''

      const diff = Math.floor(this.now / 1000) - unixtimestamp

      if (diff < 0) return 'agora'

      if (diff < 60) return 'agora'

      if (diff < 3600) {
        const min = Math.floor(diff / 60)
        return `há ${min} min`
      }

      if (diff < 86400) {
        const h = Math.floor(diff / 3600)
        return `há ${h}h`
      }

      if (diff < 2592000) {
        const d = Math.floor(diff / 86400)
        return `há ${d}d`
      }

      return this.formatDate(new Date(unixtimestamp * 1000).toISOString())
    },
  },
}
